/**
 * Shared request-composer field helpers — validation + submission state only.
 * Does not own network contracts; hosts still call QuickCreate / EvidencePipeline.
 */

export interface RequestComposerValues {
  title: string;
  description: string;
  priority: number;
  categoryId: number | null;
  screenshotDescription: string;
  includeScreenshot: boolean;
}

export interface RequestComposerValidation {
  ok: boolean;
  errors: string[];
}

export function validateRequestComposer(values: RequestComposerValues): RequestComposerValidation {
  const errors: string[] = [];
  if (!values.title.trim()) errors.push('Summary is required.');
  if (!values.description.trim()) errors.push('Details are required.');
  if (values.includeScreenshot && !values.screenshotDescription.trim()) {
    errors.push('Screenshot description is required when a screenshot is attached.');
  }
  if (![1, 2, 3, 4].includes(values.priority)) {
    errors.push('Priority is invalid.');
  }
  return { ok: errors.length === 0, errors };
}
